import { createAction, props } from '@ngrx/store';
import {
  Dependency,
  CreateDependencyRequest,
  UpdateDependencyRequest
} from '../models/dependency.interface';

// Load Dependencies
export const loadDependencies = createAction('[Dependency] Load Dependencies');

export const loadDependenciesSuccess = createAction(
  '[Dependency] Load Dependencies Success',
  props<{ dependencies: Dependency[] }>()
);

export const loadDependenciesFailure = createAction(
  '[Dependency] Load Dependencies Failure',
  props<{ error: string }>()
);

// Load Parent Dependencies
export const loadParentDependencies = createAction('[Dependency] Load Parent Dependencies');

export const loadParentDependenciesSuccess = createAction(
  '[Dependency] Load Parent Dependencies Success',
  props<{ parentDependencies: Dependency[] }>()
);

export const loadParentDependenciesFailure = createAction(
  '[Dependency] Load Parent Dependencies Failure',
  props<{ error: string }>()
);

// Create Dependency
export const createDependency = createAction(
  '[Dependency] Create Dependency',
  props<{ dependency: CreateDependencyRequest }>()
);

export const createDependencySuccess = createAction(
  '[Dependency] Create Dependency Success',
  props<{ dependency: Dependency }>()
);

export const createDependencyFailure = createAction(
  '[Dependency] Create Dependency Failure',
  props<{ error: string }>()
);

// Update Dependency
export const updateDependency = createAction(
  '[Dependency] Update Dependency',
  props<{ id: number; dependency: UpdateDependencyRequest }>()
);

export const updateDependencySuccess = createAction(
  '[Dependency] Update Dependency Success',
  props<{ dependency: Dependency }>()
);

export const updateDependencyFailure = createAction(
  '[Dependency] Update Dependency Failure',
  props<{ error: string }>()
);

// Delete Dependency
export const deleteDependency = createAction(
  '[Dependency] Delete Dependency',
  props<{ id: number }>()
);

export const deleteDependencySuccess = createAction(
  '[Dependency] Delete Dependency Success',
  props<{ id: number }>()
);

export const deleteDependencyFailure = createAction(
  '[Dependency] Delete Dependency Failure',
  props<{ error: string }>()
);

// Toggle Dependency Status
export const toggleDependencyStatus = createAction(
  '[Dependency] Toggle Dependency Status',
  props<{ id: number; isActive: boolean }>()
);

export const toggleDependencyStatusSuccess = createAction(
  '[Dependency] Toggle Dependency Status Success',
  props<{ dependency: Dependency }>()
);

export const toggleDependencyStatusFailure = createAction(
  '[Dependency] Toggle Dependency Status Failure',
  props<{ error: string }>()
);

// Search Dependencies
export const searchDependencies = createAction(
  '[Dependency] Search Dependencies',
  props<{ query: string }>()
);

export const searchDependenciesSuccess = createAction(
  '[Dependency] Search Dependencies Success',
  props<{ dependencies: Dependency[] }>()
);

export const searchDependenciesFailure = createAction(
  '[Dependency] Search Dependencies Failure',
  props<{ error: string }>()
);

// Select Dependency
export const selectDependency = createAction(
  '[Dependency] Select Dependency',
  props<{ dependency: Dependency | null }>()
);

// Clear Error
export const clearDependencyError = createAction('[Dependency] Clear Error');

// Reset State
export const resetDependencyState = createAction('[Dependency] Reset State');
